<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>商品规格</span>
				<el-button class="button" @click='edit_spec("")' type="success">新增规格</el-button>
			</div>
		</template>
		<div class="col">
			<!-- <search></search> -->
			<el-table empty-text="暂无数据" v-loading="loading" :data="specData.data"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column>
				<el-table-column prop="product_type_name" label="商品规格名" sortable>
					<template #default="scope">
						<el-popover effect="dark" trigger="hover" placement="top-start">
							<template #default>
								<p>商品模型名: {{ scope.row.type_to_spec[0].product_type_name }}</p>
								<p>商品规格名: {{ scope.row.product_spec_name }}</p>
							</template>
							<template #reference>
								<div class="name-wrapper">
									<el-tag effect="dark" type="success" size="medium">{{ scope.row.product_spec_name }}</el-tag>
								</div>
							</template>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column align="right">
					<template #header>
						<span>操作</span>
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit_spec(scope.row)">编辑</el-button>
						<el-button v-if="this.localGet('userId')==1" type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pages :total="total" :page-size="pageSize" @handleSizeChangeSub="handleSizeChangeFun" @handleCurrentChangeSub="handleCurrentChangeFun"></pages>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules" label-width="90px">
			<el-form-item label="规格名称" prop="product_spec_name">
				<el-input v-model="item.product_spec_name" size="small" placeholder="规格名称"></el-input>
			</el-form-item>
			<el-form-item label="商品模型" prop="productTypeSelect">
				<el-select v-model="item.productTypeSelect" filterable clearable placeholder="请选择">
					<el-option v-for="item in productTypeData" :key="item.id" :label="item.product_type_name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import Search from '../common/Search.vue'
	import pages  from'../common/Pagination.vue'

	export default {
		name: 'ProductType',
		data() {
			return {
				title: '新增规格',
				dialogFormVisible: false,
				total: 0,
				currentPage: 1,
				pageSize: 10,
				specData: [],
				productTypeData: [],
				loading: true,
				sort: {
					prop: 'id',
					order: 'descending'
				},
				item: {
					product_type_name: '',
					productTypeSelect: '',
				},
				search: '',
				rules: {
					product_spec_name: [{
						required: true,
						message: '请填写规格名称',
						trigger: 'blur'
					}],
					productTypeSelect: [{
						required: true,
						message: '请选择商品模型',
						trigger: 'change'
					}],
				},
			}
		},
		components: {
			Search,
			pages,
		},
		methods: {
			edit_spec(row) {
				// console.log(row)
				this.item.productTypeSelect = ''  //新增规格时  去除 默认值
				this.getProductType()
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑规格';
					this.item = temp;
					this.item.productTypeSelect = temp.type_to_spec[0].id
				} else {
					this.resetObj(this.item)
				}
				this.dialogFormVisible = true;

				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			destroy(index, row) {
				console.log(index, row)
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/product/productSpecDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getProductSpec()
				})
			},
			submit() {
				console.log(this.item);
				// return false;

				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/product/productSpecUpdate',
							data: this.item
						}).then((re) => {

							console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getProductSpec();
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})

			},
			handleSizeChangeFun(page){
				this.pageSize = page;
				this.getProductSpec();
			},
			handleCurrentChangeFun(page){
				this.currentPage = page;
				let str = '';
				str = this.$route.path+'?p='+page;
				this.$router.push(str);
				this.getProductSpec();
			},
			getProductSpec() {
				this.httpPost({
					url: '/admin/product/productSpecList',
					data:{p:this.currentPage,routePath: this.$route.path},
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.specData = temp;
					this.total = re.data.total;
					this.currentPage = re.data.currentPage;
					this.loading = false;

				}).catch((err) => {
					this.loading = false;
				})
			},
			getProductType() {
				// typeData
				this.httpPost({
					url: '/admin/product/productTypeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.productTypeData = temp;
					this.loading = false;

				}).catch((err) => {
					this.loading = false;
				})
			}
		},
		created() {
			this.getProductSpec()

		}

	}
</script>

<style>
	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.box-card {
		/* width: 480px; */
	}
</style>
